import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-profile-landing',
  templateUrl: './profile-landing.component.html',
  styleUrls: ['./profile-landing.component.scss']
})
export class ProfileLandingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
